import { render, staticRenderFns } from "./SchoolExam.vue?vue&type=template&id=e0cf3e6c&scoped=true&"
import script from "./SchoolExam.vue?vue&type=script&lang=js&"
export * from "./SchoolExam.vue?vue&type=script&lang=js&"
import style0 from "./SchoolExam.vue?vue&type=style&index=0&id=e0cf3e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cf3e6c",
  null
  
)

export default component.exports